(() => {
  'use strict';

  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const header = $('[data-site-header]');
  const drawer = $('[data-mobile-drawer]');
  const menuButtons = $$('[data-mobile-toggle]');

  const setMenu = (open) => {
    if (!header || !drawer) return;
    header.classList.toggle('menu-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    menuButtons.forEach((button) => button.setAttribute('aria-expanded', String(open)));
    document.documentElement.classList.toggle('menu-locked', open);
    document.body.style.overflow = open ? 'hidden' : '';
  };

  menuButtons.forEach((button) => {
    button.addEventListener('click', () => setMenu(!header?.classList.contains('menu-open')));
  });

  const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 18);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  $$('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href');
      if (!href || href === '#') return;
      let target;
      try { target = document.querySelector(href); } catch (_) { return; }
      if (!target) return;
      event.preventDefault();
      setMenu(false);
      target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });

  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });

    $$('.reveal,.stagger').forEach((element) => revealObserver.observe(element));
  } else {
    $$('.reveal,.stagger').forEach((element) => element.classList.add('is-visible'));
  }

  $$('[data-tool-section]').forEach((section) => {
    const buttons = $$('[data-filter]', section);
    const cards = $$('[data-category]', section);
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => item.classList.remove('active'));
        button.classList.add('active');
        const filter = button.dataset.filter || 'all';
        cards.forEach((card) => {
          card.hidden = !(filter === 'all' || card.dataset.category === filter);
        });
      });
    });
  });

  $$('.card').forEach((card) => {
    card.addEventListener('pointermove', (event) => {
      const rect = card.getBoundingClientRect();
      card.style.setProperty('--mx', `${event.clientX - rect.left}px`);
      card.style.setProperty('--my', `${event.clientY - rect.top}px`);
    });
  });

  const panel = $('[data-tilt-panel]');
  if (panel && !reducedMotion && window.matchMedia('(pointer:fine)').matches) {
    panel.addEventListener('pointermove', (event) => {
      const rect = panel.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      panel.style.transform = `perspective(1400px) rotateY(${x * 5.5 - 3.5}deg) rotateX(${-y * 4 + 1.5}deg) translate3d(0,-2px,0)`;
    });
    panel.addEventListener('pointerleave', () => { panel.style.transform = ''; });
  }

  const flowItems = $$('[data-flow-item]');
  const activityTitle = $('[data-activity-title]');
  const activitySubtitle = $('[data-activity-subtitle]');
  const activityTime = $('[data-activity-time]');
  let flowIndex = 0;
  let flowTimer;

  const activateFlow = (index) => {
    if (!flowItems.length) return;
    flowItems.forEach((item) => item.classList.remove('is-active'));
    const item = flowItems[index % flowItems.length];
    item.classList.add('is-active');
    if (activityTitle) activityTitle.textContent = item.dataset.title || '';
    if (activitySubtitle) activitySubtitle.textContent = item.dataset.subtitle || '';
    if (activityTime) activityTime.textContent = `${index % 4} s`;
  };

  if (flowItems.length) {
    activateFlow(0);
    flowItems.forEach((item, index) => {
      item.addEventListener('mouseenter', () => activateFlow(index));
      item.addEventListener('focusin', () => activateFlow(index));
    });
    if (!reducedMotion) {
      flowTimer = window.setInterval(() => {
        flowIndex = (flowIndex + 1) % flowItems.length;
        activateFlow(flowIndex);
      }, 1450);
    }
  }

  $$('[data-count-to]').forEach((element) => {
    const raw = element.dataset.countTo || element.textContent || '';
    const match = raw.match(/^(\d+(?:\.\d+)?)(.*)$/);
    if (!match || reducedMotion) return;
    const target = Number(match[1]);
    const suffix = match[2];
    const duration = 950;
    let started = false;
    const animate = () => {
      if (started) return;
      started = true;
      const start = performance.now();
      const frame = (now) => {
        const progress = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        const value = target % 1 ? (target * eased).toFixed(1) : Math.round(target * eased);
        element.textContent = `${value}${suffix}`;
        if (progress < 1) requestAnimationFrame(frame);
      };
      requestAnimationFrame(frame);
    };
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        animate();
        observer.disconnect();
      }
    }, { threshold: 0.5 });
    observer.observe(element);
  });

  $$('.accordion').forEach((accordion) => {
    $$('details', accordion).forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        $$('details', accordion).forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
    });
  });

  if (!reducedMotion && window.matchMedia('(pointer:fine)').matches) {
    $$('.btn').forEach((button) => {
      button.addEventListener('pointermove', (event) => {
        const rect = button.getBoundingClientRect();
        const x = event.clientX - rect.left - rect.width / 2;
        const y = event.clientY - rect.top - rect.height / 2;
        button.style.transform = `translate(${x * 0.055}px,${y * 0.09}px)`;
      });
      button.addEventListener('pointerleave', () => { button.style.transform = ''; });
    });
  }


  // Subtle, performance-safe hero background parallax.
  const ambientHero = $('[data-hero]');
  const ambientLayer = ambientHero ? $('[data-scroll-ambient]', ambientHero) : null;
  if (ambientHero && ambientLayer && !reducedMotion) {
    let ambientFrame = 0;
    const updateAmbient = () => {
      ambientFrame = 0;
      const rect = ambientHero.getBoundingClientRect();
      const viewport = Math.max(window.innerHeight, 1);
      const progress = Math.max(0, Math.min(1, (viewport - rect.top) / (viewport + rect.height)));
      const centered = progress - 0.5;
      const strength = Number(ambientHero.dataset.scrollMotion || 12);
      const mobileScale = window.matchMedia('(max-width: 767px)').matches ? 0.45 : 1;
      const amount = strength * mobileScale;
      ambientHero.style.setProperty('--scroll-grid-y', `${centered * amount}px`);
      ambientHero.style.setProperty('--scroll-violet-y', `${centered * amount * -0.8}px`);
      ambientHero.style.setProperty('--scroll-lime-y', `${centered * amount * 0.55}px`);
      ambientHero.style.setProperty('--scroll-beam-x', `${centered * amount * 1.15}px`);
    };
    const requestAmbient = () => {
      if (ambientFrame) return;
      ambientFrame = window.requestAnimationFrame(updateAmbient);
    };
    updateAmbient();
    window.addEventListener('scroll', requestAmbient, { passive: true });
    window.addEventListener('resize', requestAmbient, { passive: true });
  }

  // Warn only inside the Shopify editor when the WhatsApp number is missing.
  $$('[data-whatsapp-lead]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (link.dataset.whatsappConfigured === 'true') return;
      if (!window.Shopify || !window.Shopify.designMode) return;
      event.preventDefault();
      window.alert('Add your WhatsApp number in Footer → WhatsApp lead button, or Theme settings → Contact.');
    });
  });

  document.addEventListener('shopify:section:unload', () => {
    if (flowTimer) window.clearInterval(flowTimer);
  });
})();

/* Bot services category filtering */
document.addEventListener('click', function(event){
  var button = event.target.closest('[data-bot-filter]');
  if(!button) return;
  var section = button.closest('[data-bot-services]');
  if(!section) return;
  var category = button.getAttribute('data-bot-filter');
  section.querySelectorAll('[data-bot-filter]').forEach(function(item){
    var active = item === button;
    item.classList.toggle('is-active', active);
    item.setAttribute('aria-selected', active ? 'true' : 'false');
  });
  section.querySelectorAll('[data-bot-card]').forEach(function(card){
    card.hidden = category !== 'all' && card.getAttribute('data-category') !== category;
  });
});
